(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.DOT_PURPLE = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#9A51FF").s().p("AjJDJQhThTAAh2QAAh2BThTQBThTB2AAQB2AABTBTQBUBTAAB2QAAB2hUBTQhTBUh2AAQh2AAhThUg");
	this.shape.setTransform(0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DOT_PURPLE, new cjs.Rectangle(-28.3,-28.3,57,57), null);


(lib.DOT_ORGANGE = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FDAD15").s().p("AjJDJQhThTAAh2QAAh2BThTQBThTB2AAQB2AABTBTQBUBTAAB2QAAB2hUBTQhTBUh2AAQh2AAhThUg");
	this.shape.setTransform(0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DOT_ORGANGE, new cjs.Rectangle(-28.3,-28.3,57,57), null);


(lib.DOT_GREEN = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#5CDDAD").s().p("AjJDJQhThTAAh2QAAh2BThTQBThTB2AAQB2AABTBTQBUBTAAB2QAAB2hUBTQhTBUh2AAQh2AAhThUg");
	this.shape.setTransform(0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DOT_GREEN, new cjs.Rectangle(-28.3,-28.3,57,57), null);


(lib.DOT_BLUE = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#7CECF8").s().p("AjJDJQhThTAAh2QAAh2BThTQBThTB2AAQB2AABTBTQBUBTAAB2QAAB2hUBTQhTBUh2AAQh2AAhThUg");
	this.shape.setTransform(0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DOT_BLUE, new cjs.Rectangle(-28.3,-28.3,57,57), null);


// stage content:
(lib.NMI_Modular_Dots_15sec = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.DOT_PURPLE();
	this.instance.setTransform(358.3,262.55,1,1,0,0,0,0.2,0.2);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(175).to({_off:false},0).to({x:293.3,alpha:1},38,cjs.Ease.quintInOut).wait(68));

	// Layer_3
	this.instance_1 = new lib.DOT_PURPLE();
	this.instance_1.setTransform(293.75,262.55,1,1,0,0,0,0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(86).to({x:357.8,alpha:0},28,cjs.Ease.quintInOut).to({_off:true},1).wait(166));

	// DOT_ORGANGE
	this.instance_2 = new lib.DOT_ORGANGE();
	this.instance_2.setTransform(228,329.65,1,1,0,0,0,0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(281));

	// DOT_GREEN
	this.instance_3 = new lib.DOT_GREEN();
	this.instance_3.setTransform(162.1,129.3,1,1,0,0,0,0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).to({x:163},48).to({x:95.15},38,cjs.Ease.quintInOut).wait(127).to({x:160.25},35,cjs.Ease.quintInOut).to({x:161.75},32,cjs.Ease.quintInOut).wait(1));

	// DOT_GREEN
	this.instance_4 = new lib.DOT_GREEN();
	this.instance_4.setTransform(95.15,62.25,1,1,0,0,0,0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({y:62.75},48).to({y:196.25},38,cjs.Ease.quintInOut).wait(127).to({y:61.85},35,cjs.Ease.quintInOut).to({y:62.3},32,cjs.Ease.quintInOut).wait(1));

	// Layer_4
	this.instance_5 = new lib.DOT_GREEN();
	this.instance_5.setTransform(94.35,195.15,1,1,0,0,0,0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).to({x:30.25,y:196.15,alpha:0},48,cjs.Ease.quintInOut).wait(200).to({x:94.25,y:195.15,alpha:1},32,cjs.Ease.quintInOut).wait(1));

	// DOT_GREEN
	this.instance_6 = new lib.DOT_GREEN();
	this.instance_6.setTransform(161.65,195.15,1,1,0,0,0,0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({x:95.15,y:194.65},48,cjs.Ease.quintInOut).to({y:329.65},38,cjs.Ease.quintInOut).wait(127).to({y:195.25},35,cjs.Ease.quintInOut).to({x:161.3},32,cjs.Ease.quintInOut).wait(1));

	// DOT_GREEN
	this.instance_7 = new lib.DOT_GREEN();
	this.instance_7.setTransform(26.75,261.9,1,1,0,0,0,0.2,0.2);
	this.instance_7.alpha = 0;
	this.instance_7._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(48).to({_off:false},0).wait(38).to({x:95.15,alpha:1},28,cjs.Ease.quintInOut).wait(61).to({x:30.15,alpha:0},38,cjs.Ease.quintInOut).to({_off:true},1).wait(67));

	// DOT_BLUE
	this.instance_8 = new lib.DOT_BLUE();
	this.instance_8.setTransform(162.45,62,1,1,0,0,0,0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(114).to({y:128.3},27,cjs.Ease.quartInOut).to({y:62},34,cjs.Ease.quartInOut).wait(73).to({x:162,y:61.55},32,cjs.Ease.quintInOut).wait(1));

	// DOT_BLUE
	this.instance_9 = new lib.DOT_BLUE();
	this.instance_9.setTransform(228.5,128.95,1,1,0,0,0,0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_9).to({x:230.3},48).to({x:162.45},38,cjs.Ease.quintInOut).wait(28).to({y:195.25},27,cjs.Ease.quartInOut).to({y:128.95},34,cjs.Ease.quartInOut).wait(38).to({x:227.55},35,cjs.Ease.quintInOut).to({x:228.05},32,cjs.Ease.quintInOut).wait(1));

	// DOT_BLUE
	this.instance_10 = new lib.DOT_BLUE();
	this.instance_10.setTransform(94.65,129.35,1,1,0,0,0,0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({y:128.85},48).to({y:262.35},38,cjs.Ease.quintInOut).to({x:162.45},28,cjs.Ease.quintInOut).to({y:328.65},27,cjs.Ease.quartInOut).to({y:262.35},34,cjs.Ease.quartInOut).to({x:94.85},38,cjs.Ease.quintInOut).to({y:127.95},35,cjs.Ease.quintInOut).to({y:129.75},32,cjs.Ease.quintInOut).wait(1));

	// DOT_BLUE
	this.instance_11 = new lib.DOT_BLUE();
	this.instance_11.setTransform(228.85,194.6,1,1,0,0,0,0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_11).to({x:162.45},48,cjs.Ease.quintInOut).wait(66).to({y:260.9},27,cjs.Ease.quartInOut).to({y:194.6},34,cjs.Ease.quartInOut).wait(73).to({x:228.6},32,cjs.Ease.quintInOut).wait(1));

	// DOT_PURPLE
	this.instance_12 = new lib.DOT_PURPLE();
	this.instance_12.setTransform(358.5,197.05,1,1,0,0,0,0.2,0.2);
	this.instance_12.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({x:293.5,alpha:1},48,cjs.Ease.quintInOut).wait(66).to({y:128.75},27,cjs.Ease.quartInOut).to({y:195.3},34,cjs.Ease.quartInOut).to({y:197.05},38,cjs.Ease.quintInOut).wait(35).to({x:359.65,alpha:0},32,cjs.Ease.quintInOut).wait(1));

	// Layer_5
	this.instance_13 = new lib.DOT_PURPLE();
	this.instance_13.setTransform(359.1,262.25,1,1,0,0,0,0.2,0.2);
	this.instance_13.alpha = 0;
	this.instance_13._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_13).wait(175).to({_off:false},0).to({x:293.5,alpha:1},38,cjs.Ease.quintInOut).wait(68));

	// DOT_PURPLE
	this.instance_14 = new lib.DOT_PURPLE();
	this.instance_14.setTransform(228.1,262.8,1,1,0,0,0,0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_14).wait(86).to({x:293.5,y:262.5},28,cjs.Ease.quintInOut).to({y:195.7},27,cjs.Ease.quartInOut).to({y:262.25},34,cjs.Ease.quartInOut).to({x:228.5,y:262.5},38,cjs.Ease.quintInOut).wait(68));

	// DOT_PURPLE
	this.instance_15 = new lib.DOT_PURPLE();
	this.instance_15.setTransform(293.5,397.4,1,1,0,0,0,0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_15).wait(114).to({y:329.1},27,cjs.Ease.quartInOut).to({y:395.65},34,cjs.Ease.quartInOut).to({y:397.4},38,cjs.Ease.quintInOut).wait(68));

	// DOT_PURPLE
	this.instance_16 = new lib.DOT_PURPLE();
	this.instance_16.setTransform(293.5,329.65,1,1,0,0,0,0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).wait(114).to({y:261.35},27,cjs.Ease.quartInOut).to({y:327.9},34,cjs.Ease.quartInOut).to({y:329.65},38,cjs.Ease.quintInOut).wait(68));

	// DOT_ORGANGE
	this.instance_17 = new lib.DOT_ORGANGE();
	this.instance_17.setTransform(293.1,128.7,1,1,0,0,0,0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).wait(48).to({x:228},38,cjs.Ease.quintInOut).wait(127).to({x:293.1},35,cjs.Ease.quintInOut).to({y:128.25},32,cjs.Ease.quintInOut).wait(1));

	// DOT_ORGANGE
	this.instance_18 = new lib.DOT_ORGANGE();
	this.instance_18.setTransform(293.9,195.1,1,1,0,0,0,0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({x:228},48,cjs.Ease.quintInOut).wait(200).to({x:294.15},32,cjs.Ease.quintInOut).wait(1));

	// DOT_ORGANGE
	this.instance_19 = new lib.DOT_ORGANGE();
	this.instance_19.setTransform(162.3,262.35,1,1,0,0,0,0.2,0.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_19).wait(86).to({x:228},28,cjs.Ease.quintInOut).wait(61).to({x:162.35},38,cjs.Ease.quintInOut).wait(68));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(193.3,258.1,194.89999999999998,167.79999999999995);
// library properties:
lib.properties = {
	id: '5FC7015F98B8444E9102965EF833CF0A',
	width: 390,
	height: 450,
	fps: 18,
	color: "#FFFFFF",
	opacity: 0.00,
	manifest: [],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['5FC7015F98B8444E9102965EF833CF0A'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
var createjs, AdobeAn;



var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;
function init() {
  canvas = document.getElementById("canvas");
	anim_container = document.getElementById("animation_container");
	dom_overlay_container = document.getElementById("dom_overlay_container");
	var comp=AdobeAn.getComposition("5FC7015F98B8444E9102965EF833CF0A");
	var lib=comp.getLibrary();
	handleComplete({},comp);
}
function handleComplete(evt,comp) {
	//This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
	var lib=comp.getLibrary();
	var ss=comp.getSpriteSheet();
	exportRoot = new lib.NMI_Modular_Dots_15sec();
	stage = new lib.Stage(canvas);	
	//Registers the "tick" event listener.
	fnStartAnimation = function() {
		stage.addChild(exportRoot);
		createjs.Ticker.framerate = lib.properties.fps;
		createjs.Ticker.addEventListener("tick", stage);
	}	    
	//Code to support hidpi screens and responsive scaling.
	AdobeAn.makeResponsive(false,'both',false,1,[canvas,anim_container,dom_overlay_container]);	
	AdobeAn.compositionLoaded(lib.properties.id);
	fnStartAnimation();
}
$(window).on("scriptload", init);